//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../Features/Features.ShipDesign.OrientationRegionItemBuilderList.js";
import "../no/SelectObject.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[0,"AngleTolerance",1,0],[0,"DistanceTolerance",1,0],[0,"MeasureAngles",1,0],[1,"NewRegionPoint",0,"SelectNXObject",0],[0,"PlacementSide",1,0],[0,"RegionItemData",0,"Features.ShipDesign.OrientationRegionItemBuilder",0],[1,"RegionList",0,"Features.ShipDesign.OrientationRegionItemBuilderList",0],[0,"ShowSurfaceAngles",1,0],[0,"ShowTwistRate",1,0],[0,"ShowWebAngles",1,0]],[[["regionPoint"],"CreateNewRegion",{R_:{listItem:"Features.ShipDesign.OrientationRegionItemBuilder"}},1,0],[["region"],"DeleteRegion",{},1,0],[["region"],"GetNextRegion",{R_:{listItem:"Features.ShipDesign.OrientationRegionItemBuilder"}},1,0],[["curves"],"CreatePathCurve",{},1,0],[["faces"],"SetPlacementFaces",{},1,0],[["numRegions","regions"],"CreateRegionsAtFrames",{},0,0],[["regions"],"SetAnglesNormal",{},1,0]],[]];
SPLM.Features.ShipDesign.OrientationDefinitionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.OrientationDefinitionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.OrientationDefinitionBuilder.MeasureAngleTypes = Object.freeze({
    "NormaltoCurve" : "NormaltoCurve", "Orthogonal" : "Orthogonal"});

SPLM.Features.ShipDesign.OrientationDefinitionBuilder.PlacementSideTypes = Object.freeze({
    "SameAsNormal" : "SameAsNormal", "OppositeNormal" : "OppositeNormal"});

export default SPLM;